import React from "react";

const ThankYou = () => {
  return <h4>Thank You for completing this survey</h4>;
};

export default ThankYou;
